import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  DangerTextSemantic_getInstancetznd91yayzn7 as DangerTextSemantic_getInstance,
  ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance,
  styledHeaderwng1nfqibdig as styledHeader,
} from '../../theme/semantics.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  WarningSemantic_getInstance3kp0xfef7wnw4 as WarningSemantic_getInstance,
  AffirmativeSemantic_getInstance2svzxainpava5 as AffirmativeSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  Parent27xjh1mdkxxuk as Parent,
  IncomeRangeprzolg293f44 as IncomeRange,
  Family2k7vz7ddyergb as Family,
  IDqqik72jjbpsn as ID,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import {
  Addresspdncepxooezp as Address,
  ClosedLocalDateRange6599xgap66zd as ClosedLocalDateRange,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Submission20cgpazcq90xy as Submission,
  Review2bg5dlhln13tr as Review,
  FamilyApplicationReviewRequestp06ebvla4x0h as FamilyApplicationReviewRequest,
  ID3eto015dm4eyk as ID_0,
  FamilyApplication2f6semoy1a9hz as FamilyApplication,
  FamilyApplicationSubmitRequest1j7h0hdr0ven1 as FamilyApplicationSubmitRequest,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/applications.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  plus20p0vtfmu0596 as plus,
  withIndex37cl61h9v5txo as withIndex,
  toList3jhuyej2anx2q as toList,
  joinToString1cxrrlmo0chqs as joinToString,
  toMutableList20rdgwi7d3cwi as toMutableList,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_childrentbpstb2ynusu as get_children,
  get_submissionxklyxsg05uep as get_submission,
  get_family33agsz30e7i0a as get_family,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { lensPath21i5dxhjzuxep as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { modify3w2ijgzr8982m as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { addChildDialog3l2i2kmoga92p as addChildDialog } from '../children/childComponents.mjs';
import {
  RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance,
  renderToStringprxvmjepz2st as renderToString,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { renderToString2kyj9dlz89tdi as renderToString_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { confirmationDialoginprr3lfvaqc as confirmationDialog } from '../components/dialogs.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { FamilyDetailPage2yycb034kbs09 as FamilyDetailPage } from '../families/FamilyDetailPage.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { today1rno4frfjp5oe as today } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import {
  plus1oi9f9vif99u2 as plus_0,
  minushnjyym3nfk5o as minus,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  _EmailAddress___get_raw__impl__6ose226bwkbm01ev3l as _EmailAddress___get_raw__impl__6ose2,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import {
  labeledCheckbox2i8m4uxe4r9p8 as labeledCheckbox,
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  addButton16duilic9iyqp as addButton,
  iconButton2nzpucy7a6ixd as iconButton,
  keyValue1ck7xpd7fxylw as keyValue,
} from '../components/view-utilities.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import { Draftj5auffrm1u2b as Draft } from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  get_scrolling3fwkltztkpfe8 as get_scrolling,
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atBottomStart1iulwjfo1udg3 as get_atBottomStart,
  get_atBottomCenter25gz8knna6ld8 as get_atBottomCenter,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { validatedmmpm5lnzq3lm as validated_0 } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import {
  familyForm1exz237lcn7kd as familyForm,
  familyDetails18tkj8l8txyir as familyDetails,
} from '../families/familyComponents.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  tablezpetcq9vbay1 as table,
} from '../components/table.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_edit5ty08lpw30d6 as get_edit } from '../../icons.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function reviewActionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_0 = themed(element, DangerTextSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_1 = themed(this_0, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, FamilyApplicationDetailPage$reviewActionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = Button$_get_enabled_$ref_61t7nx(element_0);
  var tmp_4 = getPropertyCallableRef('enabled', 0, tmp_2, tmp_3, Button$_set_enabled_$ref_o8kynz(element_0));
  element_0.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$($this.application_1).review_1 == null);
  element_0.set_action_2ds022_k$(Action('Cancel application', VOID, VOID, VOID, VOID, VOID, FamilyApplicationDetailPage$reviewActionBar$slambda(element_0, $this)));
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_2 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_2.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_3 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_4 = themed(this_3, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_4.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_7, FamilyApplicationDetailPage$reviewActionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  var tmp_8 = KMutableProperty0();
  var tmp_9 = Button$_get_enabled_$ref_61t7nx(element_3);
  var tmp_10 = getPropertyCallableRef('enabled', 0, tmp_8, tmp_9, Button$_set_enabled_$ref_o8kynz(element_3));
  element_3.invoke_bnq13k_k$(tmp_10, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$($this.application_1).submission_1 == null) && $this$invoke.invoke_r7m7el_k$($this.application_1).review_1 == null);
  element_3.set_action_2ds022_k$(Action('Approve application', VOID, VOID, VOID, VOID, VOID, FamilyApplicationDetailPage$reviewActionBar$slambda_0(element_3, $this)));
  element_3.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function submissionActionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, FamilyApplicationDetailPage$submissionActionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, FamilyApplicationDetailPage$submissionActionBar$slambda($this, element_0));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, FamilyApplicationDetailPage$submissionActionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Submit', VOID, VOID, VOID, VOID, VOID, FamilyApplicationDetailPage$submissionActionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function FamilyApplicationDetailPage$submissionLens$lambda(app) {
  var tmp0_elvis_lhs = app.submission_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0 = new (Family())(VOID, VOID, new (Parent())('', '', app.sentTo_1), VOID, VOID, new (IncomeRange())(), VOID, new (Address())('', VOID, '', ''));
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp = new (Submission())(VOID, tmp_0, tmp$ret$0);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function FamilyApplicationDetailPage$submissionLens$lambda_0(app, newSubmission) {
  return app.copy$default_e3bxd1_k$(VOID, VOID, VOID, VOID, VOID, newSubmission);
}
function FamilyApplicationDetailPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyChildrenSectionTitle_2sss81_k$();
}
function FamilyApplicationDetailPage$render$lambda_0($this$addButton) {
  return $this$addButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAddChildButton_udkhcq_k$();
}
function FamilyApplicationDetailPage$render$lambda$slambda$slambda$slambda($child) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return plus(it, $child);
  }), 1);
}
function FamilyApplicationDetailPage$render$lambda$slambda$slambda(this$0) {
  return constructCallableReference((child, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.serialization.lensPath' call
    var this_0 = this$0.submissionLens_1;
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp = serializerOrContextual(createKType(getKClass(Submission()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$2);
    var tmp$ret$3 = get_children(it);
    var tmp_0 = lensPath(this_0, tmp$ret$3);
    yield* modify(tmp_0, FamilyApplicationDetailPage$render$lambda$slambda$slambda$slambda(child), $completion);
    return Unit_instance;
  }), 1);
}
function FamilyApplicationDetailPage$render$lambda$slambda(this$0, $this_addButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $this_addButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.submissionLens_1;
    var tmp_0 = (yield* await_0(this_0, $completion)).family_1._id_1;
    addChildDialog(this$0, tmp, tmp_0, FamilyApplicationDetailPage$render$lambda$slambda$slambda(this$0));
    return Unit_instance;
  }), 1);
}
function FamilyApplicationDetailPage$render$lambda_1(it) {
  return toList(withIndex(it));
}
function FamilyApplicationDetailPage$render$lambda_2($this$table, it) {
  return $this$table;
}
function FamilyApplicationDetailPage$render$lambda_3($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyNameColumnLabel_yh58ca_k$();
}
function FamilyApplicationDetailPage$render$lambda_4($this$text, it) {
  return it.value_1.get_fullName_9skygt_k$();
}
function FamilyApplicationDetailPage$render$lambda_5($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyBirthdateAgeColumnLabel_djfnz5_k$();
}
function FamilyApplicationDetailPage$render$lambda_6($this$text, it) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).childBirthdateWithAge_961sp2_k$(renderToString_0(it.value_1.birthDate_1, RenderSize_Abbreviation_getInstance()), it.value_1.get_ageInMonths_kafbji_k$());
}
function FamilyApplicationDetailPage$render$lambda_7($this$text) {
  return 'Race/ethnicity';
}
function FamilyApplicationDetailPage$render$lambda_8($this$text, it) {
  return joinToString(it.value_1.race_1, ', ', VOID, VOID, VOID, VOID, FamilyApplicationDetailPage$render$lambda$lambda);
}
function FamilyApplicationDetailPage$render$lambda$lambda(it) {
  return it.displayName_1;
}
function FamilyApplicationDetailPage$render$lambda_9($this$text) {
  return 'Notes';
}
function FamilyApplicationDetailPage$render$lambda_10($this$text, it) {
  return it.value_1.notes_1;
}
function FamilyApplicationDetailPage$render$lambda_11($this$custom) {
  return '';
}
function FamilyApplicationDetailPage$render$lambda$lambda_0($this$iconButton) {
  return 'Remove child';
}
function FamilyApplicationDetailPage$render$lambda$lambda$slambda$slambda($it) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = toMutableList(it);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $it;
    var tmp$ret$2 = yield* await_0(this_1, $completion);
    this_0.removeAt_6niowx_k$(tmp$ret$2.index_1);
    return this_0;
  }), 1);
}
function FamilyApplicationDetailPage$render$lambda$lambda$slambda(this$0, $it) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.serialization.lensPath' call
    var this_0 = this$0.submissionLens_1;
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp = serializerOrContextual(createKType(getKClass(Submission()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$2);
    var tmp$ret$3 = get_children(it);
    var tmp_0 = lensPath(this_0, tmp$ret$3);
    yield* modify(tmp_0, FamilyApplicationDetailPage$render$lambda$lambda$slambda$slambda($it), $completion);
    return Unit_instance;
  }), 0);
}
function FamilyApplicationDetailPage$render$lambda_12($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function FamilyApplicationDetailPage$render$lambda_13($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationSentToLabel_u2by72_k$();
}
function FamilyApplicationDetailPage$render$lambda_14($this$keyValue) {
  return 'Sent at';
}
function FamilyApplicationDetailPage$render$lambda_15($this$keyValue) {
  return $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationEmployerLabel_w3sr2u_k$();
}
function FamilyApplicationDetailPage$render$lambda_16($this$inlineLabel) {
  return $this$inlineLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationStatusLabel_3spxtr_k$();
}
function FamilyApplicationDetailPage$render$lambda_17($this$keyValue) {
  return 'Submitted at';
}
function FamilyApplicationDetailPage$render$lambda_18($this$styledHeader) {
  return 'Submission';
}
function FamilyApplicationDetailPage$render$lambda_19($this$invoke) {
  return 'Not submitted';
}
function FamilyApplicationDetailPage$render$lambda_20($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyDetailsSectionTitle_mepryw_k$();
}
function FamilyApplicationDetailPage$render$lambda_21($this$iconButton) {
  return 'Edit';
}
function FamilyApplicationDetailPage$render$lambda$slambda_0(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.editMode_1.set_revjhg_k$(true, $completion);
    return Unit_instance;
  }), 0);
}
function FamilyApplicationDetailPage$render$lambda_22($this$invoke) {
  return 'Children';
}
function FamilyApplicationDetailPage$render$lambda_23(it) {
  return toList(withIndex(it));
}
function FamilyApplicationDetailPage$render$lambda_24($this$table, it) {
  return $this$table;
}
function FamilyApplicationDetailPage$render$lambda_25($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyNameColumnLabel_yh58ca_k$();
}
function FamilyApplicationDetailPage$render$lambda_26($this$text, it) {
  return it.value_1.get_fullName_9skygt_k$();
}
function FamilyApplicationDetailPage$render$lambda_27($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyBirthdateAgeColumnLabel_djfnz5_k$();
}
function FamilyApplicationDetailPage$render$lambda_28($this$text, it) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).childBirthdateWithAge_961sp2_k$(renderToString_0(it.value_1.birthDate_1, RenderSize_Abbreviation_getInstance()), it.value_1.get_ageInMonths_kafbji_k$());
}
function FamilyApplicationDetailPage$render$lambda_29($this$text) {
  return 'Race/ethnicity';
}
function FamilyApplicationDetailPage$render$lambda_30($this$text, it) {
  return joinToString(it.value_1.race_1, ', ', VOID, VOID, VOID, VOID, FamilyApplicationDetailPage$render$lambda$lambda_1);
}
function FamilyApplicationDetailPage$render$lambda$lambda_1(it) {
  return it.displayName_1;
}
function FamilyApplicationDetailPage$render$lambda_31($this$text) {
  return 'Notes';
}
function FamilyApplicationDetailPage$render$lambda_32($this$text, it) {
  return it.value_1.notes_1;
}
function FamilyApplicationDetailPage$render$lambda_33($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function FamilyApplicationDetailPage$reviewActionBar$lambda($this$invoke) {
  return 'Cancel application';
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return constructCallableReference(() => p0.get_enabled_pcr8o8_k$(), 0, 0, 156, VOID, [p0]);
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_enabled_tswf75_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 157, VOID, [p0]);
}
function FamilyApplicationDetailPage$reviewActionBar$slambda$lambda($this$confirmationDialog) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$confirmationDialog.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$confirmationDialog.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, FamilyApplicationDetailPage$reviewActionBar$slambda$lambda$lambda);
  element.onStartup_vrxh3i_k$();
  $this$confirmationDialog.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function FamilyApplicationDetailPage$reviewActionBar$slambda$lambda$lambda($this$invoke) {
  return 'This cannot be undone. To re-invite this family, you will have to create a new invite.';
}
function FamilyApplicationDetailPage$reviewActionBar$slambda$slambda(this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    var updated = yield* session.api_1.get_familyApplication_7vdin7_k$().reviewFamilyApplication_y1gw00_k$(new (FamilyApplicationReviewRequest())(this$0.id_1, new (Review())(VOID, false)), $completion);
    session.get_familyApplications_uxaw4w_k$().localInsert_9xyne_k$(updated);
    var tmp = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    toast(tmp, tmp$ret$1.get_familyApplicationRejectedToast_5xw86e_k$());
    return Unit_instance;
  }), 0);
}
function FamilyApplicationDetailPage$reviewActionBar$slambda($$this$button, this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    var tmp_0 = FamilyApplicationDetailPage$reviewActionBar$slambda$lambda;
    var tmp_1 = DangerSemantic_getInstance();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_strings(AppState_getInstance());
    var tmp_2 = (yield* await_1(this_0, $completion)).get_crudCancelButton_yk4tir_k$();
    confirmationDialog(tmp, 'Cancel application?', tmp_0, 'Cancel application', tmp_1, tmp_2, VOID, FamilyApplicationDetailPage$reviewActionBar$slambda$slambda(this$0, $$this$button));
    return Unit_instance;
  }), 1);
}
function FamilyApplicationDetailPage$reviewActionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationApproveButton_w2gak_k$();
}
function FamilyApplicationDetailPage$reviewActionBar$slambda$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationApproveConfirmBody_j98ydk_k$();
}
function FamilyApplicationDetailPage$reviewActionBar$slambda$lambda$lambda_1($this$invoke) {
  return 'The following email addresses will have access to this family and their children:';
}
function FamilyApplicationDetailPage$reviewActionBar$slambda$lambda$lambda_2($this$labeledCheckbox) {
  return 'Set up employer authorization now';
}
function FamilyApplicationDetailPage$reviewActionBar$slambda$slambda_0($setUpAuthorizationNow, $authorizationStart, $authorizationEnd, this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $setUpAuthorizationNow;
    if (yield* await_1(this_0, $completion)) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = $authorizationStart;
      var tmp0_elvis_lhs = yield* await_1(this_1, $completion);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var start = tmp_0;
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = $authorizationEnd;
      var tmp1_elvis_lhs = yield* await_1(this_2, $completion);
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var end = tmp_1;
      tmp = new (ClosedLocalDateRange())(start, end);
    } else {
      tmp = null;
    }
    var authorizationRange = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_currentSessionNotNull();
    var session = yield* await_0(this_3, $completion);
    var updated = yield* session.api_1.get_familyApplication_7vdin7_k$().reviewFamilyApplication_y1gw00_k$(new (FamilyApplicationReviewRequest())(this$0.id_1, new (Review())(VOID, true), authorizationRange), $completion);
    session.get_familyApplications_uxaw4w_k$().localInsert_9xyne_k$(updated);
    var tmp2_safe_receiver = updated.submission_1;
    var newFamily = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.family_1;
    var tmp_2 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = get_strings(AppState_getInstance());
    var tmp$ret$4 = yield* await_1(this_4, $completion);
    toast(tmp_2, tmp$ret$4.get_familyApplicationApprovedToast_ghct71_k$());
    var tmp_3;
    if (!(newFamily == null)) {
      session.get_families_is4v1x_k$().localInsert_9xyne_k$(newFamily);
      get_pageNavigator($$this$button.get_context_h02k06_k$()).reset_diztr_k$(new (FamilyDetailPage())(newFamily._id_1));
      tmp_3 = Unit_instance;
    }
    return Unit_instance;
  }), 0);
}
function FamilyApplicationDetailPage$reviewActionBar$slambda_0($$this$button, this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var setUpAuthorizationNow = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(true);
    var authorizationStart = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(today());
    var authorizationEnd = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(minus(plus_0(today(), DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(1)), DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, VOID, 1)));
    var tmp = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_strings(AppState_getInstance());
    var tmp_0 = (yield* await_1(this_0, $completion)).get_familyApplicationApproveConfirmHeading_oqxjis_k$();
    var tmp_1 = ($this$confirmationDialog) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_0 = get_bold($this$confirmationDialog);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (TextView())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
      element.invoke_bnq13k_k$(tmp_1, FamilyApplicationDetailPage$reviewActionBar$slambda$lambda$lambda_0);
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (TextView())($this$confirmationDialog.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      $this$confirmationDialog.willAddChild_hz2iwc_k$(element_0);
      var tmp_2 = KMutableProperty0();
      var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_0);
      var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_0));
      element_0.invoke_bnq13k_k$(tmp_4, FamilyApplicationDetailPage$reviewActionBar$slambda$lambda$lambda_1);
      element_0.onStartup_vrxh3i_k$();
      $this$confirmationDialog.addChild_2qpft2_k$(element_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (TextView())($this$confirmationDialog.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      $this$confirmationDialog.willAddChild_hz2iwc_k$(element_1);
      var tmp_5 = KMutableProperty0();
      var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_1);
      var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_1));
      element_1.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
        var tmp = _EmailAddress___get_raw__impl__6ose2($this$invoke.invoke_r7m7el_k$(this$0.application_1).sentTo_1);
        var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this$0.application_1).submission_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.family_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.primaryParent_1;
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.email_1;
        var tmp_0;
        var tmp_1 = tmp3_safe_receiver;
        if ((tmp_1 == null ? null : new (EmailAddress())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = _EmailAddress___get_raw__impl__6ose2(tmp3_safe_receiver);
        }
        var tmp_2 = tmp_0;
        var tmp4_safe_receiver = $this$invoke.invoke_r7m7el_k$(this$0.application_1).submission_1;
        var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.family_1;
        var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.secondaryParent_1;
        var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.email_1;
        var tmp_3;
        var tmp_4 = tmp7_safe_receiver;
        if ((tmp_4 == null ? null : new (EmailAddress())(tmp_4)) == null) {
          tmp_3 = null;
        } else {
          tmp_3 = _EmailAddress___get_raw__impl__6ose2(tmp7_safe_receiver);
        }
        return joinToString(toSet(listOfNotNull([tmp, tmp_2, tmp_3])), '\n');
      });
      element_1.onStartup_vrxh3i_k$();
      $this$confirmationDialog.addChild_2qpft2_k$(element_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (Separator())($this$confirmationDialog.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      $this$confirmationDialog.willAddChild_hz2iwc_k$(element_2);
      element_2.onStartup_vrxh3i_k$();
      $this$confirmationDialog.addChild_2qpft2_k$(element_2);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_1 = get_bold($this$confirmationDialog);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = new (TextView())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      this_1.willAddChild_hz2iwc_k$(element_3);
      var tmp_8 = KMutableProperty0();
      var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_3);
      var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_3));
      element_3.invoke_bnq13k_k$(tmp_10, ($this$invoke) => {
        var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this$0.employer_1);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
        return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      });
      element_3.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element_3);
      labeledCheckbox($this$confirmationDialog, FamilyApplicationDetailPage$reviewActionBar$slambda$lambda$lambda_2, setUpAuthorizationNow);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      var this_2 = shownWhen($this$confirmationDialog, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(setUpAuthorizationNow));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (RowOrCol())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      this_2.willAddChild_hz2iwc_k$(element_4);
      element_4.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      var this_3 = weight(element_4, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_5);
      this_3.willAddChild_hz2iwc_k$(element_5);
      element_5.set_content_lzqutq_k$('Start');
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
      var this_4 = themed(element_5, FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_6 = new (LocalDateField())(this_4.get_context_h02k06_k$());
      ensureOutermostElement(element_6);
      this_4.willAddChild_hz2iwc_k$(element_6);
      element_6.bind_gesskf_k$(element_6.content_1, authorizationStart);
      element_6.onStartup_vrxh3i_k$();
      this_4.addChild_2qpft2_k$(element_6);
      element_5.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_5);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      var this_5 = weight(element_4, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_7 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_5.get_context_h02k06_k$());
      ensureOutermostElement(element_7);
      this_5.willAddChild_hz2iwc_k$(element_7);
      element_7.set_content_lzqutq_k$('End');
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
      var this_6 = themed(element_7, FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_8 = new (LocalDateField())(this_6.get_context_h02k06_k$());
      ensureOutermostElement(element_8);
      this_6.willAddChild_hz2iwc_k$(element_8);
      element_8.bind_gesskf_k$(element_8.content_1, authorizationEnd);
      element_8.onStartup_vrxh3i_k$();
      this_6.addChild_2qpft2_k$(element_8);
      element_7.onStartup_vrxh3i_k$();
      this_5.addChild_2qpft2_k$(element_7);
      element_4.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_4);
      return Unit_instance;
    };
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp_2 = (yield* await_1(this_1, $completion)).get_familyApplicationApproveButton_w2gak_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_strings(AppState_getInstance());
    var tmp_3 = (yield* await_1(this_2, $completion)).get_crudCancelButton_yk4tir_k$();
    confirmationDialog(tmp, tmp_0, tmp_1, tmp_2, VOID, tmp_3, VOID, FamilyApplicationDetailPage$reviewActionBar$slambda$slambda_0(setUpAuthorizationNow, authorizationStart, authorizationEnd, this$0, $$this$button));
    return Unit_instance;
  }), 1);
}
function FamilyApplicationDetailPage$submissionActionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function FamilyApplicationDetailPage$submissionActionBar$slambda(this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.application_1.cancel_2l89ey_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = (yield* await_0(this_0, $completion)).isAdmin_1;
    if (yield* await_0(this_1, $completion)) {
      yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    } else {
      get_pageNavigator($$this$button.get_context_h02k06_k$()).goBack_kj7lzl_k$();
    }
    return Unit_instance;
  }), 0);
}
function FamilyApplicationDetailPage$submissionActionBar$lambda_0($this$invoke) {
  return 'Submit';
}
function FamilyApplicationDetailPage$submissionActionBar$slambda$lambda($this$confirmationDialog) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$confirmationDialog.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$confirmationDialog.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, FamilyApplicationDetailPage$submissionActionBar$slambda$lambda$lambda);
  element.onStartup_vrxh3i_k$();
  $this$confirmationDialog.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function FamilyApplicationDetailPage$submissionActionBar$slambda$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1) ? 'This will update the application submission.' : 'The application will be sent to TCG.';
}
function FamilyApplicationDetailPage$submissionActionBar$slambda$slambda(this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.showSecondParent_1;
    if (!(yield* await_0(this_0, $completion))) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = this$0.submissionLens_1;
      var tmp_0 = yield* await_0(this_1, $completion);
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = this$0.submissionLens_1;
      var tmp$ret$2 = yield* await_0(this_2, $completion);
      tmp = yield* this$0.submissionLens_1.set_revjhg_k$(tmp_0.copy$default_100iqh_k$(VOID, tmp$ret$2.family_1.copy$default_8deers_k$(VOID, VOID, VOID, null)), $completion);
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_currentSessionNotNull();
    var session = yield* await_0(this_3, $completion);
    var tmp_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = this$0.application_1.get_published_wg9pad_k$();
    if ((yield* await_0(this_4, $completion)).submission_1 == null) {
      var tmp_2 = session.api_1.get_familyApplication_7vdin7_k$();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_5 = this$0.submissionLens_1;
      var tmp$ret$5 = yield* await_0(this_5, $completion);
      tmp_1 = yield* tmp_2.submitFamilyApplication_euzvcw_k$(new (FamilyApplicationSubmitRequest())(this$0.id_1, tmp$ret$5), $completion);
    } else {
      var tmp_3 = session.get_familyApplications_uxaw4w_k$().get_6ueaa7_k$(new (ID_0())(this$0.id_1));
      // Inline function 'com.lightningkite.services.database.modification' call
      // Inline function 'kotlin.apply' call
      var this_6 = new (ModificationBuilder())();
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_4 = serializerOrContextual(createKType(getKClass(FamilyApplication()), arrayOf([]), false));
      var tmp$ret$10 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
      var it = new (DataClassPathSelf())(tmp$ret$10);
      var tmp_5 = get_submission(it);
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_7 = this$0.submissionLens_1;
      var tmp$ret$12 = yield* await_0(this_7, $completion);
      this_6.assign_vtsfu6_k$(tmp_5, tmp$ret$12);
      var tmp$ret$6 = this_6.build_1k0s4u_k$();
      tmp_1 = yield* tmp_3.modify_ff53f_k$(tmp$ret$6, $completion);
    }
    var tmp0_elvis_lhs = tmp_1;
    var tmp_6;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_6 = tmp0_elvis_lhs;
    }
    var updated = tmp_6;
    yield* session.get_familyApplications_uxaw4w_k$().totallyInvalidate_d4stw5_k$($completion);
    session.get_familyApplications_uxaw4w_k$().localInsert_9xyne_k$(updated);
    yield* this$0.application_1.publish_xq9q2e_k$($completion);
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    var tmp_7 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_8 = get_strings(AppState_getInstance());
    var tmp$ret$13 = yield* await_1(this_8, $completion);
    toast(tmp_7, tmp$ret$13.get_familySavedToast_l5bkyb_k$());
    return Unit_instance;
  }), 0);
}
function FamilyApplicationDetailPage$submissionActionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.application_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* this$0.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      this$0.formIssuesDialog$default_8ey6bo_k$($$this$button.get_context_h02k06_k$());
      return Unit_instance;
    }
    var tmp_0 = $$this$button.get_context_h02k06_k$();
    var tmp_1 = FamilyApplicationDetailPage$submissionActionBar$slambda$lambda;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp_2 = (yield* await_1(this_1, $completion)).get_crudCancelButton_yk4tir_k$();
    confirmationDialog(tmp_0, 'Submit application', tmp_1, 'Submit', VOID, tmp_2, VOID, FamilyApplicationDetailPage$submissionActionBar$slambda$slambda(this$0, $$this$button));
    return Unit_instance;
  }), 1);
}
var FamilyApplicationDetailPageClass;
function FamilyApplicationDetailPage() {
  if (FamilyApplicationDetailPageClass === VOID) {
    class $ extends Form() {
      constructor(id) {
        super();
        this.id_1 = id;
        var tmp = this;
        tmp.application_1 = validated(Draft(($this$Draft) => $this$Draft.awaitNotNull_2lqt5h_k$($this$Draft.invoke_r7m7el_k$(get_currentSessionNotNull()).get_familyApplications_uxaw4w_k$().get_6ueaa7_k$(new (ID_0())(this.id_1)))));
        var tmp_0 = this;
        tmp_0.employer_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$().get_6ueaa7_k$(new (ID())($this$remember.invoke_r7m7el_k$(this.application_1).employer_1))));
        var tmp_1 = this;
        var tmp_2 = FamilyApplicationDetailPage$submissionLens$lambda;
        tmp_1.submissionLens_1 = this.application_1.lens_u4wb4z_k$(tmp_2, FamilyApplicationDetailPage$submissionLens$lambda_0);
        var tmp_3 = this;
        tmp_3.showSecondParent_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => !($this$mutableRemember.invoke_r7m7el_k$(this.submissionLens_1).family_1.secondaryParent_1 == null));
        var tmp_4 = this;
        tmp_4.editMode_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => $this$mutableRemember.invoke_r7m7el_k$(this.application_1.get_published_wg9pad_k$()).submission_1 == null && !$this$mutableRemember.invoke_r7m7el_k$($this$mutableRemember.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1));
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).familyApplicationDetailTitle_7az5kv_k$(EmailAddress__toString_impl_artjh3($this$remember.invoke_r7m7el_k$(this.application_1).sentTo_1)));
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.application_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.get_title_iz32un_k$()));
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (Separator())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        submissionActionBar(this, element_2);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_5 = this.submissionLens_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_2 = serializerOrContextual(createKType(getKClass(Submission()), arrayOf([]), false));
        var tmp$ret$25 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$25);
        var tmp$ret$26 = get_family(it);
        var tmp$ret$23 = lensPath(this_5, tmp$ret$26);
        familyForm(this, element_2, validated_0(tmp$ret$23), this.showSecondParent_1, true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (RowOrCol())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_2.willAddChild_hz2iwc_k$(element_4);
        element_4.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_6 = get_atBottomStart(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_7 = weight(this_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_7.willAddChild_hz2iwc_k$(element_5);
        element_5.set_themeChoice_py59um_k$(element_5.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
        var tmp_3 = KMutableProperty0();
        var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_5, FamilyApplicationDetailPage$render$lambda);
        element_5.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_8 = get_centered(element_4);
        var tmp_6 = themed(this_8, ImportantSemantic_getInstance());
        var tmp_7 = FamilyApplicationDetailPage$render$lambda_0;
        addButton(tmp_6, tmp_7, ($this$addButton) => {
          $this$addButton.set_action_2ds022_k$(Action('Add child', VOID, VOID, VOID, VOID, VOID, FamilyApplicationDetailPage$render$lambda$slambda(this, $this$addButton)));
          return Unit_instance;
        });
        element_4.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_9 = this.submissionLens_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_8 = serializerOrContextual(createKType(getKClass(Submission()), arrayOf([]), false));
        var tmp$ret$40 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$40);
        var tmp$ret$41 = get_children(it_0);
        var tmp_9 = lensPath(this_9, tmp$ret$41);
        var tmp_10 = lens(tmp_9, FamilyApplicationDetailPage$render$lambda_1);
        var tmp_11 = FamilyApplicationDetailPage$render$lambda_2;
        var tmp_12 = Companion_instance_0;
        var tmp_13 = FamilyApplicationDetailPage$render$lambda_3;
        var tmp_14 = tmp_12.text$default_gwb2zv_k$(tmp_13, VOID, FamilyApplicationDetailPage$render$lambda_4);
        var tmp_15 = Companion_instance_0;
        var tmp_16 = FamilyApplicationDetailPage$render$lambda_5;
        var tmp_17 = tmp_15.text$default_gwb2zv_k$(tmp_16, VOID, FamilyApplicationDetailPage$render$lambda_6);
        var tmp_18 = Companion_instance_0;
        var tmp_19 = FamilyApplicationDetailPage$render$lambda_7;
        var tmp_20 = tmp_18.text$default_gwb2zv_k$(tmp_19, VOID, FamilyApplicationDetailPage$render$lambda_8);
        var tmp_21 = Companion_instance_0;
        var tmp_22 = FamilyApplicationDetailPage$render$lambda_9;
        var tmp_23 = tmp_21.text_y5ktm4_k$(tmp_22, 2.0, FamilyApplicationDetailPage$render$lambda_10);
        var tmp_24 = Companion_instance_0;
        var tmp_25 = FamilyApplicationDetailPage$render$lambda_11;
        table(element_2, tmp_10, tmp_11, [tmp_14, tmp_17, tmp_20, tmp_23, tmp_24.custom_k0krgj_k$(tmp_25, 0.5, ($this$custom, it) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())($this$custom.get_context_h02k06_k$());
          ensureOutermostElement(element);
          $this$custom.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          var tmp = Companion_getInstance_0().delete_1;
          var tmp_0 = FamilyApplicationDetailPage$render$lambda$lambda_0;
          iconButton(element, tmp, tmp_0, ($this$iconButton) => {
            onClick($this$iconButton, VOID, VOID, VOID, FamilyApplicationDetailPage$render$lambda$lambda$slambda(this, it));
            return Unit_instance;
          });
          element.onStartup_vrxh3i_k$();
          $this$custom.addChild_2qpft2_k$(element);
          return Unit_instance;
        })]);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Separator())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        element_2.willAddChild_hz2iwc_k$(element_6);
        element_6.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_6);
        submissionActionBar(this, element_2);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_10 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_10.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_11 = themed(element_7, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (RowOrCol())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_11.willAddChild_hz2iwc_k$(element_8);
        element_8.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_12 = shownWhen(element_8, VOID, VOID, FamilyApplicationDetailPage$render$lambda_12);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (RowOrCol())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        this_12.willAddChild_hz2iwc_k$(element_9);
        element_9.set_vertical_nuap32_k$(true);
        var tmp_26 = FamilyApplicationDetailPage$render$lambda_13;
        keyValue(element_9, tmp_26, ($this$keyValue) => EmailAddress__toString_impl_artjh3($this$keyValue.invoke_r7m7el_k$(this.application_1).sentTo_1));
        var tmp_27 = FamilyApplicationDetailPage$render$lambda_14;
        keyValue(element_9, tmp_27, ($this$keyValue) => renderToString($this$keyValue.invoke_r7m7el_k$(this.application_1).createdAt_1));
        var tmp_28 = FamilyApplicationDetailPage$render$lambda_15;
        keyValue(element_9, tmp_28, ($this$keyValue) => {
          var tmp0_safe_receiver = $this$keyValue.invoke_r7m7el_k$(this.employer_1);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
          return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        });
        element_9.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_9);
        // Inline function 'org.thecommunitygroupinc.cares.views.components.inlineLabel' call
        var label = FamilyApplicationDetailPage$render$lambda_16;
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(element_8.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        element_8.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_13 = sizeConstraints(get_centered(element_10), VOID, VOID, VOID, VOID, VOID, get_rem(10));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (TextView())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_13.willAddChild_hz2iwc_k$(element_11);
        element_11.set_themeChoice_py59um_k$(element_11.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_29 = KMutableProperty0();
        var tmp_30 = TextView$_get_content_$ref_4pzcwl(element_11);
        var tmp_31 = getPropertyCallableRef('content', 0, tmp_29, tmp_30, TextView$_set_content_$ref_pketfb(element_11));
        element_11.invoke_bnq13k_k$(tmp_31, ($this$invoke) => label($this$invoke));
        element_11.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_11);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_14 = get_centered(element_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_15 = weight(this_14, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (RowOrCol())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        this_15.willAddChild_hz2iwc_k$(element_12);
        element_12.set_vertical_nuap32_k$(false);
        var tmp_32 = themed(element_12, ChipSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_16 = dynamicThemed(tmp_32, ($this$dynamicThemed) => {
          var tmp;
          var tmp0_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(this.application_1).review_1;
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.approved_1) === true) {
            tmp = AffirmativeSemantic_getInstance();
          } else {
            var tmp1_safe_receiver = $this$dynamicThemed.invoke_r7m7el_k$(this.application_1).review_1;
            if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.approved_1) === false) {
              tmp = DangerSemantic_getInstance();
            } else {
              if ($this$dynamicThemed.invoke_r7m7el_k$(this.application_1).submission_1 == null) {
                tmp = null;
              } else {
                tmp = WarningSemantic_getInstance();
              }
            }
          }
          return tmp;
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (TextView())(this_16.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_16.willAddChild_hz2iwc_k$(element_13);
        var tmp_33 = KMutableProperty0();
        var tmp_34 = TextView$_get_content_$ref_4pzcwl(element_13);
        var tmp_35 = getPropertyCallableRef('content', 0, tmp_33, tmp_34, TextView$_set_content_$ref_pketfb(element_13));
        element_13.invoke_bnq13k_k$(tmp_35, ($this$invoke) => {
          var tmp;
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.application_1).review_1;
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.approved_1) === true) {
            tmp = 'Approved';
          } else {
            var tmp1_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.application_1).review_1;
            if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.approved_1) === false) {
              tmp = 'Cancelled';
            } else {
              if ($this$invoke.invoke_r7m7el_k$(this.application_1).submission_1 == null) {
                tmp = 'Invited';
              } else {
                tmp = 'Submitted';
              }
            }
          }
          return tmp;
        });
        element_13.onStartup_vrxh3i_k$();
        this_16.addChild_2qpft2_k$(element_13);
        element_12.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_12);
        element_10.onStartup_vrxh3i_k$();
        element_8.addChild_2qpft2_k$(element_10);
        var tmp_36 = FamilyApplicationDetailPage$render$lambda_17;
        keyValue(element_8, tmp_36, ($this$keyValue) => {
          var tmp0_safe_receiver = $this$keyValue.invoke_r7m7el_k$(this.application_1).submission_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.submittedAt_1;
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.at_1;
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : renderToString(tmp2_safe_receiver);
          return tmp3_elvis_lhs == null ? $this$keyValue.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyApplicationNotSubmittedLabel_1cvz7t_k$() : tmp3_elvis_lhs;
        });
        element_8.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (Space())(element_7.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        element_7.willAddChild_hz2iwc_k$(element_14);
        element_14.onStartup_vrxh3i_k$();
        element_7.addChild_2qpft2_k$(element_14);
        styledHeader(element_7, FamilyApplicationDetailPage$render$lambda_18);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_17 = themed(element_7, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (RowOrCol())(this_17.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        this_17.willAddChild_hz2iwc_k$(element_15);
        element_15.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_18 = shownWhen(element_15, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.application_1).submission_1 == null);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (RowOrCol())(this_18.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        this_18.willAddChild_hz2iwc_k$(element_16);
        element_16.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_19 = themed(element_16, ChipSemantic_getInstance().plus_duvq05_k$(WarningSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (TextView())(this_19.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        this_19.willAddChild_hz2iwc_k$(element_17);
        var tmp_37 = KMutableProperty0();
        var tmp_38 = TextView$_get_content_$ref_4pzcwl(element_17);
        var tmp_39 = getPropertyCallableRef('content', 0, tmp_37, tmp_38, TextView$_set_content_$ref_pketfb(element_17));
        element_17.invoke_bnq13k_k$(tmp_39, FamilyApplicationDetailPage$render$lambda_19);
        element_17.onStartup_vrxh3i_k$();
        this_19.addChild_2qpft2_k$(element_17);
        element_16.onStartup_vrxh3i_k$();
        this_18.addChild_2qpft2_k$(element_16);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_20 = shownWhen(element_15, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(this.application_1.get_published_wg9pad_k$()).submission_1 == null));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (RowOrCol())(this_20.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        this_20.willAddChild_hz2iwc_k$(element_18);
        element_18.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (RowOrCol())(element_18.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        element_18.willAddChild_hz2iwc_k$(element_19);
        element_19.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_21 = get_atBottomCenter(element_19);
        var tmp$ret$104 = weight(this_21, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_22 = get_bold(tmp$ret$104);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (TextView())(this_22.get_context_h02k06_k$());
        ensureOutermostElement(element_20);
        this_22.willAddChild_hz2iwc_k$(element_20);
        var tmp_40 = KMutableProperty0();
        var tmp_41 = TextView$_get_content_$ref_4pzcwl(element_20);
        var tmp_42 = getPropertyCallableRef('content', 0, tmp_40, tmp_41, TextView$_set_content_$ref_pketfb(element_20));
        element_20.invoke_bnq13k_k$(tmp_42, FamilyApplicationDetailPage$render$lambda_20);
        element_20.onStartup_vrxh3i_k$();
        this_22.addChild_2qpft2_k$(element_20);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_23 = shownWhen(element_19, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1) && $this$shownWhen.invoke_r7m7el_k$(this.application_1).review_1 == null);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_21 = new (RowOrCol())(this_23.get_context_h02k06_k$());
        ensureOutermostElement(element_21);
        this_23.willAddChild_hz2iwc_k$(element_21);
        element_21.set_vertical_nuap32_k$(true);
        var tmp_43 = get_edit(Companion_getInstance_0());
        var tmp_44 = FamilyApplicationDetailPage$render$lambda_21;
        iconButton(element_21, tmp_43, tmp_44, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, FamilyApplicationDetailPage$render$lambda$slambda_0(this));
          return Unit_instance;
        });
        element_21.onStartup_vrxh3i_k$();
        this_23.addChild_2qpft2_k$(element_21);
        element_19.onStartup_vrxh3i_k$();
        element_18.addChild_2qpft2_k$(element_19);
        var f = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(this.application_1.get_published_wg9pad_k$()).submission_1;
          return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.family_1;
        });
        var family = get_waitForNotNull(f);
        familyDetails(element_18, family);
        element_18.onStartup_vrxh3i_k$();
        this_20.addChild_2qpft2_k$(element_18);
        element_15.onStartup_vrxh3i_k$();
        this_17.addChild_2qpft2_k$(element_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_24 = shownWhen(element_7, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(this.application_1.get_published_wg9pad_k$()).submission_1 == null));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_22 = new (RowOrCol())(this_24.get_context_h02k06_k$());
        ensureOutermostElement(element_22);
        this_24.willAddChild_hz2iwc_k$(element_22);
        element_22.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_23 = new (Space())(element_22.get_context_h02k06_k$());
        ensureOutermostElement(element_23);
        element_22.willAddChild_hz2iwc_k$(element_23);
        element_23.onStartup_vrxh3i_k$();
        element_22.addChild_2qpft2_k$(element_23);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_25 = get_bold(element_22);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_24 = new (TextView())(this_25.get_context_h02k06_k$());
        ensureOutermostElement(element_24);
        this_25.willAddChild_hz2iwc_k$(element_24);
        var tmp_45 = KMutableProperty0();
        var tmp_46 = TextView$_get_content_$ref_4pzcwl(element_24);
        var tmp_47 = getPropertyCallableRef('content', 0, tmp_45, tmp_46, TextView$_set_content_$ref_pketfb(element_24));
        element_24.invoke_bnq13k_k$(tmp_47, FamilyApplicationDetailPage$render$lambda_22);
        element_24.onStartup_vrxh3i_k$();
        this_25.addChild_2qpft2_k$(element_24);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_26 = this.submissionLens_1;
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_48 = serializerOrContextual(createKType(getKClass(Submission()), arrayOf([]), false));
        var tmp$ret$124 = isInterface(tmp_48, KSerializer()) ? tmp_48 : THROW_CCE();
        var it_1 = new (DataClassPathSelf())(tmp$ret$124);
        var tmp$ret$125 = get_children(it_1);
        var tmp_49 = lensPath(this_26, tmp$ret$125);
        var tmp_50 = lens(tmp_49, FamilyApplicationDetailPage$render$lambda_23);
        var tmp_51 = FamilyApplicationDetailPage$render$lambda_24;
        var tmp_52 = Companion_instance_0;
        var tmp_53 = FamilyApplicationDetailPage$render$lambda_25;
        var tmp_54 = tmp_52.text$default_gwb2zv_k$(tmp_53, VOID, FamilyApplicationDetailPage$render$lambda_26);
        var tmp_55 = Companion_instance_0;
        var tmp_56 = FamilyApplicationDetailPage$render$lambda_27;
        var tmp_57 = tmp_55.text$default_gwb2zv_k$(tmp_56, VOID, FamilyApplicationDetailPage$render$lambda_28);
        var tmp_58 = Companion_instance_0;
        var tmp_59 = FamilyApplicationDetailPage$render$lambda_29;
        var tmp_60 = tmp_58.text$default_gwb2zv_k$(tmp_59, VOID, FamilyApplicationDetailPage$render$lambda_30);
        var tmp_61 = Companion_instance_0;
        var tmp_62 = FamilyApplicationDetailPage$render$lambda_31;
        table(element_22, tmp_50, tmp_51, [tmp_54, tmp_57, tmp_60, tmp_61.text_y5ktm4_k$(tmp_62, 2.0, FamilyApplicationDetailPage$render$lambda_32)]);
        element_22.onStartup_vrxh3i_k$();
        this_24.addChild_2qpft2_k$(element_22);
        element_7.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_25 = new (Space())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_25);
        element.willAddChild_hz2iwc_k$(element_25);
        element_25.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_25);
        reviewActionBar(this, shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1) && !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1)));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_27 = shownWhen(element, VOID, VOID, FamilyApplicationDetailPage$render$lambda_33);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_26 = new (Space())(this_27.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_26);
        this_27.willAddChild_hz2iwc_k$(element_26);
        element_26.onStartup_vrxh3i_k$();
        this_27.addChild_2qpft2_k$(element_26);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'FamilyApplicationDetailPage', VOID, VOID, [Page(), CanBlockBack()]);
    FamilyApplicationDetailPageClass = $;
  }
  return FamilyApplicationDetailPageClass;
}
//region block: exports
export {
  Button$_set_enabled_$ref_o8kynz as Button$_set_enabled_$ref_o8kynzfmpduwei6tot,
  Button$_get_enabled_$ref_61t7nx as Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n,
  FamilyApplicationDetailPage as FamilyApplicationDetailPage3ca1ne4h64yjy,
};
//endregion

//# sourceMappingURL=FamilyApplicationDetailPage.mjs.map
